import React from 'react';
import { SHADCN, TYPO } from '../theme';

// ── <SquareItemLink> ─────────────────────────────────────────────────────────
// Lien sortant vers la fiche article Square. Neutre (fg souligné), jamais mint :
// ce n'est pas un signal de santé, juste une navigation externe.
export default function SquareItemLink({ itemId, label = 'Ouvrir →', style }) {
  return (
    <a
      href={`https://app.squareup.com/dashboard/items/library/${itemId}`}
      target="_blank"
      rel="noopener noreferrer"
      style={{
        ...TYPO.caption,
        fontWeight: 500,
        color: SHADCN.fg,
        textDecoration: 'underline',
        textUnderlineOffset: 3,
        textDecorationColor: SHADCN.border,
        whiteSpace: 'nowrap',
        ...style,
      }}
    >
      {label}
    </a>
  );
}
